module.exports = __webpack_public_path__ + "static/img/hot.a295fa8c.gif";